import ky from "ky-universal";
import baseFields from "../../config/api/baseFields";

export default async function fetcher(url, options) {
  try {
    const res = await ky(url, {
      ...options,
      searchParams: {
        ...baseFields,
        ...options?.searchParams,
      },
    });

    return await res.json();
  } catch (error) {
    console.error(`${url} error`);
    throw error;
  }
}
